import React, { useState, useEffect } from 'react';
import { chatService } from '../services/chatService';
import { Book } from 'lucide-react';
import { Notification } from './Notification';

export const Notepad: React.FC = () => {
  const [content, setContent] = useState('');
  const [notification, setNotification] = useState<{ message: string, type: 'success' | 'error' } | null>(null);

  useEffect(() => {
    const unsubscribe = chatService.subscribeToNotepad(setContent);
    return () => unsubscribe();
  }, []);

  const handleSave = async () => {
    try {
      await chatService.updateNotepad(content);
      setNotification({ message: 'Notepad saved successfully!', type: 'success' });
    } catch (error) {
      setNotification({ message: 'Failed to save notepad.', type: 'error' });
      console.error(error);
    }
  };

  return (
    <div className="mt-8">
      {notification && (
        <Notification
          message={notification.message}
          type={notification.type}
          onClose={() => setNotification(null)}
        />
      )}
      <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-4 flex items-center gap-2">
        <Book className="w-4 h-4" />
        Shared Notepad
      </h3>
      <textarea
        value={content}
        onChange={(e) => setContent(e.target.value)}
        className="w-full h-32 p-2 text-xs text-gray-700 bg-gray-100 rounded-md"
        maxLength={500}
      />
      <button onClick={handleSave} className="mt-2 w-full bg-blue-600 text-white text-xs font-bold py-2 px-4 rounded-md hover:bg-blue-700 transition-colors">
        Save Notepad
      </button>
    </div>
  );
};
